import {SearchBarApp} from "./components/search-bar";

const careersSearchApp = new SearchBarApp({wrapId: 'search-bar'}, jQuery).init();